import { useRouter } from 'next/router';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filterLoveFromCommunityCategories } from '../../../../utils/community';
import { setHighlightItem } from '../../../store/slices/common/commonSlice';
import CategorySubNavbarComponent from './CategorySubNavbarComponent';
import { FOR_YOU_COMMUNITY_ROUTE } from '../../../../utils/routes';

const CommunityCategoryBar = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { city = 'zurich', tag_filter = 'most_popular' } = router.query;
  const lang = useSelector(({ common }) => common?.language);

  const categories = useSelector(({ community }) => {
    return community?.categories;
  });

  const categoryTabHandler = async (tab) => {
    if (tab?.name === lang?.common?.home) {
      await dispatch(setHighlightItem(lang?.common?.home));
      router.push({
        pathname: `/community`,
        query: { city, tag_filter },
      });
    } else if (tab?.name === 'for_you') {
      await dispatch(setHighlightItem(tab?.id));
      router.push(FOR_YOU_COMMUNITY_ROUTE(city));
    } else {
      await dispatch(setHighlightItem(tab?.id));
      router.push({
        pathname: `/community/categories/${tab?.id}`,
        query: { city, tag_filter },
      });
    }
  };

  return (
    <CategorySubNavbarComponent
      categories={filterLoveFromCommunityCategories(categories)}
      categoryTabHandler={categoryTabHandler}
    />
  );
};

export default React.memo(CommunityCategoryBar);
